module.exports = __webpack_public_path__ + "img/logout.66bdadbd.png";